import {MapProps} from "pages/dashboard/map/MapProps"
import {CustomOverlayMap, Map, MapMarker, MarkerClusterer, Polyline, ZoomControl} from "react-kakao-maps-sdk"
import {WheelchairMark} from "./WheelchairMark"
import {observer} from "mobx-react"
import {useRootStore} from "store/useRootStore"
import {useKakaoMap} from "./kakaoMapHook"
import {useMemo, useRef, useState} from "react"
import {isEmergencyStatus, isErrorStatus, isNoneOperationStatus, RealDevice} from "dto/realdevice/devices"
import {filterDevice} from "pages/dashboard/Dashboard"
import {isValidCoordinate} from "utils/coordinate-validator"

const clusterMinLevel = 3

export const KakaoMap = observer(({centerPosition, zoomLevel, devices}: MapProps) => {
    const mapRef = useRef<kakao.maps.Map>(null)
    const [currentLevel, setCurrentLevel] = useState(0)
    const {
        dashboardStore: {
            selectedDevice,
            setShowRealDeviceInfo,
            showPathTrackingInfo,
            map, setMap,
            pathTrackingStore: {location: locationInPath, page: pathPage, pageSize: pathPageSize},
            impactHistoryStore: {location: locationInImpact},
            deviceStatusFilterCondition, searchKeyword,
            deviceStatusCategory
        },
        envStore: {env}
    } = useRootStore()
    const {changeMapType, mapType, pathTrackingList} = useKakaoMap(selectedDevice, map)

    const polyLineList = useMemo(() => {
        return (pathTrackingList || []).filter(isValidCoordinate)
    }, [pathTrackingList])
    if (!window.kakao) {
        return (<div>Loading...</div>)
    }
    // console.log('polyLineList', polyLineList, 'env:', env)
    let filteredDevices = devices || []
    // if (deviceStatusFilterCondition) {
    //     filteredDevices = filteredDevices.filter(dev => deviceStatusFilterCondition.some(stat => dev.communicationDevice.status === stat))
    // }
    filteredDevices = filterDevice(deviceStatusCategory, devices)
    if (searchKeyword) {
        filteredDevices = filteredDevices.filter(dev => (dev.name.includes(searchKeyword) || dev.communicationDevice.eui.includes(searchKeyword)))
    }
    return (
        <Map center={centerPosition} style={{position: "absolute", top: 0, right: 0, bottom: 0, left: 0}}
             onCreate={map => {
                 setMap(map)
                 setCurrentLevel(map.getLevel())
             }} level={zoomLevel} ref={mapRef}
             onZoomChanged={map => setCurrentLevel(map?.getLevel())}>
            <ZoomControl position={kakao.maps.ControlPosition.TOPRIGHT}/>
            <div className="tags has-addons" style={{position: "absolute", right: 40, top: 5, zIndex: 1000}}>
                <span className={`tag is-medium is-clickable ${mapType === "ROADMAP" ? "is-link" : ""}`}
                      onClick={() => changeMapType("ROADMAP")}>일반지도</span>
                <span className={`tag is-medium is-clickable ${mapType === "HYBRID" ? "is-link" : ""}`}
                      onClick={() => changeMapType("HYBRID")}>하이브리드</span>
            </div>
            <MarkerClusterer
                averageCenter={true} // 클러스터에 포함된 마커들의 평균 위치를 클러스터 마커 위치로 설정
                minLevel={clusterMinLevel} // 클러스터 할 최소 지도 레벨
            >
                {filteredDevices.map(device => {
                    if (!device.communicationDevice.currentLatLng) return null
                    const latLng = {
                        lat: parseFloat(device.communicationDevice.currentLatLng?.lat),
                        lng: parseFloat(device.communicationDevice.currentLatLng?.lng)
                    }
                    return (
                        <WheelchairMark position={latLng} key={device.id}
                                        status={device.communicationDevice.status}
                                        onClick={() => setShowRealDeviceInfo(true, device)}
                                        currentLevel={currentLevel}
                                        minLevel={clusterMinLevel}
                        >
                            <div className="columns">
                                <div className="column">{device.name}
                                    {/*<span style={{fontSize: 8, color: "darkgrey"}}>[{device.communicationDevice.eui}]</span>*/}
                                </div>
                            </div>
                        </WheelchairMark>
                    )
                })}
            </MarkerClusterer>
            {/*{(pathTrackingList && pathTrackingList.length > 0 && showPathTrackingInfo) && (*/}
            {/*    <Polyline path={pathTrackingList}/>*/}
            {/*)}*/}
            {(polyLineList.length > 0 && showPathTrackingInfo) &&
                (
                    <>
                        <Polyline path={polyLineList}/>
                        {polyLineList.map((path, idx) => (
                            <CustomOverlayMap key={path.no} position={{
                                lat: path.lat || 0,
                                lng: path.lng || 0
                            }}>
                                <span className="tag is-small" style={{opacity: .8}}>
                                    {pathPage * pathPageSize + idx + 1}
                                    {/*{path.no}*/}
                                </span>
                            </CustomOverlayMap>
                        ))}
                    </>
                )
            }
            {(locationInPath) && (
                <CustomOverlayMap position={locationInPath} zIndex={500}>
                    <div style={{width: 30}} className="tag is-danger">{locationInPath.no}</div>
                </CustomOverlayMap>
            )}

            {(locationInImpact) && (
                <MapMarker position={locationInImpact}/>
            )}

        </Map>
    )

})